var _circle, _path, _path2, _path3, _path4, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDolphinBadge(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#00edff",
    r: 256
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 256l-1-25L378 98 219 216l-38 167-43 69 51 51a256 256 0 00323-247z",
    fill: "#0ac0ea"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M339 178v5c0 30-16 57-42 72l-7-72z",
    fill: "#0053bf"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M415 153l-18-15c-6-38-38-66-77-68-28-1-55 5-79 17a83 83 0 00-75-16l36 44-18 21-5 8c-27 38-36 85-25 129l21 109c-21 3-37 21-37 42v28c23 0 42-18 43-41 1 23 20 41 43 41v-28c0-21-16-39-37-42l11-54c3-17 9-33 18-47 37-64 97-108 167-96l21 3a19 19 0 0011-35z",
    fill: "#0053bf"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M415 153l-18-15c-6-38-38-66-77-68-22-1-44 3-64 10v149l13-12 4 38c23-13 38-37 41-63 21-8 45-11 69-7l21 3a19 19 0 0011-35z",
    fill: "#1b3b6b"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 366.5,
    cy: 129.4,
    fill: "#afb4c8",
    r: 7.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDolphinBadge);
export default __webpack_public_path__ + "static/media/dolphin-badge.4ed69499791eaa7d3355ca191a4110b4.svg";
export { ForwardRef as ReactComponent };